/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import getValidationErros from '~/utils/getValidationsErrors';
import { useAuth } from '~/hooks/Auth';

import { Container } from './styles';
import Input from '~/components/Input';

import logo from '~/assets/logos/logo-name.svg';

interface IFormData {
  code: string;
}

const Login: React.FC = () => {
  const { signIn } = useAuth();
  const formRef = useRef<FormHandles>(null);

  useEffect(() => {
    if (window.ReactNativeWebView) {
      const data = {
        stausBarColor: '#ff6900',
      };

      window.ReactNativeWebView.postMessage(JSON.stringify(data));
    }
  }, []);

  const handleSubmit = useCallback(
    async (data: IFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          code: Yup.string().required('O código é obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        signIn({
          code: data.code,
        });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Código inválido!');
        }
      }
    },
    [signIn]
  );

  return (
    <Container>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <div className="ret-up ret-left" />
            <div className="ret-up ret-right" />
            <img src={logo} alt="Logo Koro" className="logo" />
          </div>

          <div className="col-11 px-3">
            <h2 className="h6 text-white fw-normal mb-3">
              Insira o código do evento para continuar
            </h2>
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              className="d-flex flex-column pb-3"
            >
              <label className="mb-3">
                <span className="text-white fw-normal d-block mb-2 size" />
                <Input name="code" />
              </label>

              <button
                type="submit"
                className="btn btn-login h6 fw-normal py-2 mt-4"
              >
                Entrar
              </button>
            </Form>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Login;
